import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Button } from '@/components/Button/Button';
import { Warning } from '@/components/Icons/Warning';
import { PoweredBy } from '@/components/PoweredBy/PoweredBy';
import { showPoweredBySelector } from '@/state/config';
import { webChatStateState } from '@/state/socket';
import styles from './ErrorPage.module.scss';
export const ErrorPage = ({ error }) => {
    const showPoweredBy = useRecoilValue(showPoweredBySelector);
    const setWebChatState = useSetRecoilState(webChatStateState);
    const { t } = useTranslation();
    const handleRestartClick = () => {
        setWebChatState("create" /* WebChatState.Create */);
    };
    return (_jsxs("div", { className: styles.container, children: [_jsx(Warning, {}), _jsx("p", { children: error.message_key ? t(error.message_key) : error.message }), _jsx(Button, { onClick: handleRestartClick, children: t('survey.restart_conversation') }), showPoweredBy && _jsx(PoweredBy, {})] }));
};
